import { Box, Typography } from '@mui/material'
import React from 'react'
import { SectionTitle } from '../../../components'

const ServicesServices = () => {
    const services = [
        {
            name:'Residential Construction',
            text:'We specialize in building high-end custom homes, duplexes, and multi-family residences. Our team works closely with clients to bring their vision to life through innovative design, top-quality materials, and expert craftsmanship.'
        },
        {
            name:'Commercial Construction',
            text:' From office buildings to retail spaces and hospitality venues, we deliver efficient, sustainable, and functional commercial spaces tailored to your business needs and brand identity.'
        },
        {
            name:'Institutional Projects',
            text:'With experience in government-funded developments, we handle projects for schools, community centers, and healthcare facilities, ensuring full compliance with safety standards, timelines, and budget requirements.'
        },
        {
            name:'Industrial Construction',
            text:' We build durable and efficient facilities, including warehouses, manufacturing plants, and logistics centers—designed to meet your operational needs and support long-term growth.'
        },
        {
            name:'Renovation & Remodelling',
            text:"Breathe new life into your space with our remodeling services. Whether it's a single room or a complete transformation, we provide creative and practical solutions that maximize space, function, and aesthetics."
        },
        {
            name:'Interior Design',
            text:' Our in-house design team brings creativity and precision to every detail\u2014balancing beauty, comfort, and functionality for homes and businesses alike.'
        },
        {
            name:'Project Management',
            text:' From planning to completion, our experienced project managers ensure smooth execution, clear communication, and on-time delivery. We prioritize transparency, accountability, and client satisfaction.'
        },
        {
            name:'Sustainable Building Solutions',
            text:' Pangu integrates eco-friendly practices into every stage of construction\u2014from using sustainable materials to optimizing energy efficiency\u2014helping clients reduce their environmental impact while adding long-term value.'
        }
    ]
  return (
    <Box
        sx={{
            background:'linear-gradient(to right, #A6A6A6, #fefefe)',
        }}
    >
    <Box
        sx={{
            background: `
            linear-gradient(135deg, #e0e0e0 25%, transparent 25%) -10px 0,
            linear-gradient(225deg, #e0e0e0 25%, transparent 25%) -10px 0,
            linear-gradient(315deg, #e0e0e0 25%, transparent 25%),
            linear-gradient(45deg, #e0e0e0 25%, transparent 25%)
          `
        }}
    >
        <SectionTitle firstTitleWord='Our' secondTitleWord='Services' 
            textStyle={{ 
                fontWeight:'500', 
                fontSize:'2.5rem', 
                '@media screen and (max-width: 762px)':{
                    fontSize:'2rem'
                    },
                }}
            sx={{
                paddingY:'1rem'
            }}
                />
        <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        width: '100%',
                        padding: '1rem',
                        boxSizing: 'border-box',
                        '@media screen and (max-width: 762px)': {
                            flexDirection: 'column',
                        },
                    }}
                >
                    {/* Left Column */}
                    <Box
                        sx={{
                            width: '50%',
                            paddingRight: '2rem',
                            boxSizing: 'border-box',
                            '@media screen and (max-width: 762px)': {
                                width: '100%',
                                paddingRight: '0',
                            },
                        }}
                    >
                        {services.slice(0, 4).map((item, index) => (
                            <Box
                                key={index}
                                sx={{
                                    marginBottom: '2rem',
                                }}
                            >
                                <Typography
                                    variant="h1"
                                    sx={{
                                        fontFamily: 'var(--title-font)',
                                        fontSize: '2rem',
                                        fontWeight: '500',
                                    }}
                                >
                                    {item.name.split(' ')[0] + ' '}
                                    <span
                                        style={{
                                            color: 'var(--color-secondary)',
                                            fontWeight: '700',
                                        }}
                                    >
                                        {item.name.split(' ').slice(1).join(' ')}
                                    </span>
                                </Typography>
                                <Typography
                                    sx={{
                                        fontFamily: 'var(--text-font)',
                                        padding: '1rem 0',
                                    }}
                                >
                                    {item.text}
                                </Typography>
                            </Box>
                        ))}
                    </Box>

                    {/* Right Column */}
                    <Box
                        sx={{
                            width: '50%',
                            paddingLeft: '2rem',
                            boxSizing: 'border-box',
                            '@media screen and (max-width: 762px)': {
                                width: '100%',
                                paddingLeft: '0',
                            },
                        }}
                    >
                        {services.slice(4).map((item, index) => (
                            <Box
                                key={index}
                                sx={{
                                    marginBottom: '2rem',
                                }}
                            >
                                <Typography
                                    variant="h1"
                                    sx={{
                                        fontFamily: 'var(--title-font)',
                                        fontSize: '2rem',
                                        fontWeight: '500',
                                    }}
                                >
                                    {item.name.split(' ')[0] + ' '}
                                    <span
                                        style={{
                                            color: 'var(--color-secondary)',
                                            fontWeight: '700',
                                        }}
                                    >
                                        {item.name.split(' ').slice(1).join(' ')}
                                    </span>
                                </Typography>
                                <Typography
                                    sx={{
                                        fontFamily: 'var(--text-font)',
                                        padding: '1rem 0',
                                    }}
                                >
                                    {item.text}
                                </Typography>
                            </Box>
                        ))}
                    </Box>
                </Box>
    </Box>
    </Box>
  )
}

export default ServicesServices

// {services.map((item, index) => {
//     // Split the name into the first word and the rest
//     const [firstWord, ...restWords] = item.name.split(' ');

//     return (
//         <Box key={index}
//             sx={{
//                 boxSizing:'border-box',
//                 '@media screen and (max-width: 762px)':{
//                     paddingY:'1rem'
//                 }
//             }}
//         >
//         <Typography
//             variant="h1"
//             sx={{
//             fontFamily: 'var(--title-font)',
//             fontSize: '2rem',
//             fontWeight: '500',
//             }}
//         >
            
//             {firstWord + ' '}
//             <span
//             style={{
//                 color: 'var(--color-secondary)', // Style for the first word
//                 fontWeight: '700', // Example: Make the first word bold
//             }}
//             >
//                 {restWords.join(' ')} {/* Join the remaining words */}
//             </span>{' '}
            
//         </Typography>
//         <Typography
//             sx={{
//             fontFamily: 'var(--text-font)',
//             padding: '2rem 5rem',
//             '@media screen and (max-width: 762px)':{
//                 padding:'2rem 0 0 1rem'
//             }
//             }}
//         >
//             {item.text}
//         </Typography>
//         </Box>
//     );
//     })}